export default __webpack_public_path__ + "static/media/63324cd82fa21207c7f2d364ac545324.svg";